<template>
    <el-dialog
            width="30%"
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="80px" class="tenant-dialog-form">
            <el-form-item label="编码" prop="code">
                <el-input v-model="dataForm.code" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="name">
                <el-input v-model="dataForm.name" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="邮箱模板" prop="name">
                <el-upload
                        ref="upload"
                        :auto-upload="false"
                        drag
                        action
                        :http-request="upload"
                        multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div cla3ss="el-upload__tip" slot="tip">只能上传ftl文件，且不超过500kb</div>
                </el-upload>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {uploadOfficeTemplate} from '@/controller/sys'
    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    id: 0,
                    code: '',
                    name: '',
                    status: 1
                },
                dataRule: {
                    code: [
                        {required: true, message: '模板编码不能为空', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '模板名称不能为空', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            upload(obj) {
                let formData = new FormData()
                formData.set('id', this.dataForm.id)
                formData.set('file', obj.file)
                formData.set('tmplCode', this.dataForm.code)
                formData.set('tmplName', this.dataForm.name)
                uploadOfficeTemplate(formData).then(data => {
                    if(data.code === '00'){
                        this.$refs.upload.clearFiles()
                        this.$message.success({
                            message: '发布成功！',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }
                })
            },
            init(id, code, name) {
                this.dataForm.id = id || 0
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.dataForm.code = code
                        this.dataForm.name = name
                    }
                })
            },
            // 表单提交
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$refs.upload.submit();
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    .el-dialog__body {
        .tenant-dialog-form {
            width: 90%;
        }
        .el-upload-dragger, .el-upload{
            width: 100%;
        }
    }
</style>
